import { render, staticRenderFns } from "./BannerApp.vue?vue&type=template&id=0a8f0ae0&"
import script from "./BannerApp.vue?vue&type=script&lang=js&"
export * from "./BannerApp.vue?vue&type=script&lang=js&"
import style0 from "./BannerApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports